// extracted by mini-css-extract-plugin
module.exports = {"moreInformation":"DateTextInformation_moreInformation__16wXN"};